export default "__VITE_ASSET__DboA_lIx__"